export default {
  Navigation: {
    Dashboard: 'Tổng quan',
    Classroom: 'Lớp học',
    Document: 'Học liệu',
    Exercise: 'Bài tập',
    NewsFeed: 'Bảng tin',
    Calendar: 'Lịch học',
    Student: 'Học sinh',
    Teacher: 'Giáo viên',
    Storage: 'Kho học liệu',
    Examination: 'Kiểm tra',
    MoreOption: 'Xem Thêm',
    Practice: 'Tự học',
    ExamStore: 'Đề kiểm tra',
    ExamPeriod: 'Bài kiểm tra',
    Assignment: 'Phân công',
    SchoolExamPeriod: 'Kế hoạch',
    ListCalendar: 'Danh sách lịch',
    ManagerCalendar: 'Quản lý lịch',
    AccountCalendar: 'Phòng học', // giáo viên
    Meeting: 'Phòng học', // học sinh
    Training: 'Đào tạo MISA EMIS'
  }
}
